import React from "react";
import { useState, useEffect } from "react";
import GlobalFunctions from "../Services/GlobalFunctions";
import DialogoLoading from "../Components/DialogoLoading";
import Swal from "sweetalert2";
import axios from "axios";

const Requests = (params) => {
  const glob = new GlobalFunctions();
  const [telefono, setTelefono] = useState("");
  const [mensaje, setMensaje] = useState("Los campos con * son obligatorios");
  const [datosPersonales, setDatosPersonales] = useState({
    nombre: "",
    cedula: "",
    direccion: "",
    prestamo: 0,
    periodicidad: "Semanal",
    telefonos: [],
    otros: "",
    sugerencias: "",
    valorPrestamoAnterior: 0,
  });
  const [datosDialogo, setDatosDialogo] = useState({
    mensaje: "",
    imagen: "",
    saldo: 0,
  });

  useEffect(() => {
    if (datosPersonales.cedula != params.cliente.cedula) {
      getDatosCliente();
    }
  }, [params.cliente]);

  function sweetAlert(mensaje) {
    Swal.fire({
      title: mensaje,
      icon: "warning",
      showCancelButton: false,
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
    });
  }

  function getDatosCliente() {
    setDatosPersonales((valores) => ({
      ...valores,
      cedula: params.cliente.cedula,
      nombre: params.cliente.nombre,
      direccion: params.cliente.direccion,
      prestamo: params.cliente.prestamo.valorprestamo,
      periodicidad:
        params.cliente.prestamo.periodicidad == ""
          ? "Quincenal"
          : params.cliente.prestamo.periodicidad,
      telefonos: params.cliente.telefonos,
    }));
  }

  function cambioCedula(event) {
    setDatosPersonales((valores) => ({
      ...valores,
      cedula: event.target.value,
    }));
  }

  function cambioNombre(event) {
    setDatosPersonales((valores) => ({
      ...valores,
      nombre: event.target.value,
    }));
  }

  function cambioDireccion(event) {
    setDatosPersonales((valores) => ({
      ...valores,
      direccion: event.target.value,
    }));
  }

  function cambioPrestamo(event) {
    setDatosPersonales((valores) => ({
      ...valores,
      prestamo: event.target.value,
    }));
  }

  function cambioPeriodicidad(event) {
    setDatosPersonales((valores) => ({
      ...valores,
      periodicidad: event.target.value,
    }));
  }

  function cambioOtros(event) {
    setDatosPersonales((valores) => ({
      ...valores,
      otros: event.target.value,
    }));
  }

  function borrarTelefono(tel) {
    const temp = datosPersonales.telefonos.filter((art) => art !== tel);
    setDatosPersonales((valores) => ({
      ...valores,
      telefonos: temp,
    }));
  }

  function cambioTelefono(event) {
    setTelefono(event.target.value);
  }

  function agregarTelefono() {
    if (telefono !== "") {
      let tels = datosPersonales.telefonos;
      tels.push(telefono);
      setDatosPersonales((valores) => ({
        ...valores,
        telefonos: tels,
      }));
      setTelefono("");
    }
  }

  function enviarFormulario() {
    if (validarCamposVacios() == 5) {
      document.getElementById("btnOpenModalLoading").click();
      axios
        .post(process.env.REACT_APP_API_URL + "/setSolicitud2", datosPersonales)
        .then((response) => {
          document.getElementById("btnCloseModalLoading").click();
          Swal.fire({
            title: "Solicitud enviada correctamente.",
            icon: "success",
            showConfirmButton: true,
          });
          document.getElementById("btnGoLista").click();
        })
        .catch((error) => {
          document.getElementById("btnCloseModalLoading").click();
          setMensaje("Error al enviar la solicitud.");
          Swal.fire({
            title: "Error al enviar",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
          });
        });
    }
  }

  function validarCamposVacios() {
    let lleno = 0;
    if (datosPersonales.cedula === "") {
      setMensaje("Ingresa tu número de cédula!");
      sweetAlert("Ingresa tu número de cédula!");
    } else {
      lleno++;
    }
    if (datosPersonales.nombre === "") {
      setMensaje("Ingresa tu nombre!");
      sweetAlert("Ingresa tu nombre!");
    } else {
      lleno++;
    }
    if (datosPersonales.direccion === "") {
      setMensaje("Ingresa tu dirección!");
      sweetAlert("Ingresa tu dirección!");
    } else {
      lleno++;
    }
    if (datosPersonales.prestamo === "") {
      setMensaje("Ingresa un valor de crédito!");
      sweetAlert("Ingresa un valor de crédito!");
    } else {
      lleno++;
    }
    if (datosPersonales.telefonos.length < 1) {
      setMensaje("Debes ingresar al menos un télefono!");
      sweetAlert("Debes ingresar al menos un télefono!");
    } else {
      lleno++;
    }
    setTimeout(() => {
      setMensaje("Los campos con * son obligatorios.");
    }, 5000);
    return lleno;
  }

  return (
    <div>
      <h3 style={{ color: "black", textAlign: "center", marginTop: "0.5em" }}>
        Solicitud de credito N° 2. Ya soy cliente.
      </h3>
      <div className="container border rounded">
        <div className="row">
          <div
            style={{ textAlign: "left" }}
            className="col-lg-6 col-md-6 col-sm-12 col-12"
          >
            <p style={{ textAlign: "left", color: "red" }}>{mensaje}</p>
            <p
              id="ingresaCedula"
              style={{ textAlign: "justify", color: "black" }}
            >
              Ingresa número de cédula.
              <strong style={{ color: "red" }}>*</strong>
            </p>
            <input
              onChange={cambioCedula}
              defaultValue={
                datosPersonales.cedula ? datosPersonales.cedula : ""
              }
              type="number"
              className="form-control"
              placeholder="Número de cedula"
              style={{ marginBottom: "0.5em" }}
            />
            <span style={{ color: "red" }}>
              <strong>*</strong>
            </span>
            <input
              type="text"
              onChange={cambioNombre}
              defaultValue={
                datosPersonales.nombre ? datosPersonales.nombre : ""
              }
              className="form-control"
              placeholder="Nombre"
              style={{ marginBottom: "0.5em" }}
            />
            <span style={{ textAlign: "left", color: "red" }}>
              <strong>*</strong>
            </span>
            <textarea
              onChange={cambioDireccion}
              defaultValue={
                datosPersonales.direccion ? datosPersonales.direccion : ""
              }
              rows="2"
              className="form-control"
              placeholder="Direccion domicilio"
              style={{ marginBottom: "0.8em" }}
            ></textarea>
            <label style={{ textAlign: "left", color: "black" }}>
              Télefonos{" "}
              <span style={{ textAlign: "left", color: "red" }}>
                <strong>*</strong>
              </span>
            </label>
            {/* div telefonos */}
            <div style={{ textAlign: "center" }} className="container">
              <div className="row justify-content-center">
                {datosPersonales.telefonos.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{ margin: "0.2em", height: "3.6em" }}
                      className="col-lg-4 col-md-4 col-sm-4 col-4 border"
                    >
                      <p>{item}</p>
                      <svg
                        onClick={() => borrarTelefono(item)}
                        data-dismiss="modal"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        className="bi bi-x-square"
                        viewBox="0 0 16 16"
                        style={{
                          marginTop: "-1.6em",
                          color: "red",
                          cursor: "pointer",
                        }}
                      >
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </div>
                  );
                })}
              </div>
              <div style={{ marginTop: "0.2em" }} className="row">
                <div className="col-sm-8 col-8">
                  <input
                    onChange={cambioTelefono}
                    onBlur={agregarTelefono}
                    value={telefono}
                    type="number"
                    className="form-control"
                    placeholder="Nuevo número télefono"
                  />
                </div>
                <div className="col-sm-4 col-4">
                  <a type="button" className="btn btn-success">
                    Agregar
                  </a>
                </div>
              </div>
            </div>
            {/* fin div telefonos */}
            <br></br>
            <p style={{ textAlign: "justify", color: "black" }}>
              Otros:
              <br></br>
              Cuéntanos si haz modificado algún otro de tus datos, estaremos muy
              agradecidos.
            </p>
            <textarea
              style={{ marginBottom: "0.8em" }}
              rows="2"
              onChange={cambioOtros}
              className="form-control"
              placeholder="Ejemplo: direccion de trabajo... telefono trabajo...Información de referencias...."
            ></textarea>
            <label style={{ textAlign: "justify", color: "black" }}>
              Valor de crédito a solicitar.
              <strong style={{ color: "red" }}>*</strong>
            </label>
            <input
              type="number"
              onChange={cambioPrestamo}
              defaultValue={
                datosPersonales.prestamo ? datosPersonales.prestamo : ""
              }
              className="form-control"
              style={{ marginBottom: "0.8em" }}
            />
            <label style={{ textAlign: "justify", color: "black" }}>
              Periodicidad .<strong style={{ color: "red" }}>*</strong>
            </label>
            <select
              value={datosPersonales.periodicidad}
              onChange={cambioPeriodicidad}
              className="form-select"
            >
              <option value="diaria">Diaria</option>
              <option value="semanal">Semanal</option>
              <option value="quincenal">Quincenal</option>
              <option value="mensual">Mensual</option>
            </select>
            <br></br>
            <div style={{ textAlign: "center" }}>
              <button
                id="btnEnviar"
                type="button"
                onClick={enviarFormulario}
                className="btn btn-success"
              >
                Enviar solicitud
              </button>
              <button
                id="btnLoading"
                type="button"
                disabled
                style={{ backgroundColor: "gray", display: "none" }}
                className="btn btn-primary"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Loading...</span>
              </button>
            </div>
            <hr />
            <button style={{display: 'none'}} id="btnGoLista" onClick={params.goLista}></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Requests;
